// GN: trilho horizontal de produtos (scroll-snap) com setas que aparecem só quando há o que rolar.
if (!customElements.get('gn-trilho')) {
  customElements.define(
    'gn-trilho',
    class GnTrilho extends HTMLElement {
      connectedCallback() {
        this.lista = this.querySelector('.gn-cm__trilho');
        this.ant = this.querySelector('.gn-cm__seta--ant');
        this.prox = this.querySelector('.gn-cm__seta--prox');
        if (!this.lista || !this.ant || !this.prox) return;
        this.ant.addEventListener('click', () => this.rolar(-1));
        this.prox.addEventListener('click', () => this.rolar(1));
        this.lista.addEventListener('scroll', () => this.atualizar(), { passive: true });
        new ResizeObserver(() => this.atualizar()).observe(this.lista);
        this.atualizar();
      }

      rolar(direcao) {
        const item = this.lista.querySelector('.gn-cm__item');
        const passo = item ? item.getBoundingClientRect().width + 16 : this.lista.clientWidth * 0.8;
        this.lista.scrollBy({ left: direcao * passo, behavior: 'smooth' });
      }

      atualizar() {
        const { scrollLeft, scrollWidth, clientWidth } = this.lista;
        this.ant.hidden = scrollLeft <= 4;
        this.prox.hidden = scrollLeft + clientWidth >= scrollWidth - 4;
      }
    }
  );
}
